import { render, staticRenderFns } from "./spaceshipIcon.vue?vue&type=template&id=c453f58a&"
import script from "./spaceshipIcon.vue?vue&type=script&lang=js&"
export * from "./spaceshipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports